import {useCallback} from 'react';
import {useSelector} from 'react-redux';

import {getDatesFormats} from 'src/openapi/admin/apis/GetDatesFormatsApi';
import {useAppDispatch} from 'src/store/hooks';

import {selectDateFormats} from './services/dictionary-slice';

export const useDateFormats = () => {
    const apiDispatch = useAppDispatch();
    const dateFormats = useSelector(selectDateFormats);

    const loadDateFormats = useCallback(() => {
        if (!dateFormats.length) {
            apiDispatch(getDatesFormats());
        }
    }, [dateFormats.length, apiDispatch]);

    return {dateFormats, loadDateFormats};
};
